document.addEventListener('DOMContentLoaded', function () {
  var inlineCta = document.querySelector('.local-mv__layer--cta');
  var fixedCta = document.querySelector('.local-fixed-cta');

  if (!inlineCta || !fixedCta) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        fixedCta.classList.remove('is-visible');
        fixedCta.setAttribute('aria-hidden', 'true');
      } else {
        fixedCta.classList.add('is-visible');
        fixedCta.setAttribute('aria-hidden', 'false');
      }
    });
  });

  observer.observe(inlineCta);
});
